export default "__VITE_ASSET__11daf498__"